<mat-form-field
  appearance="outline"
  floatLabel="always"
  class="sia-inputs-full sia-input"
  [subscriptSizing]="showBottomMargin() ? 'fixed' : 'dynamic'"
>
  <mat-label
    >{{ label() | siaTranslate }}
    @if (info()) {
      <span
        [siaTooltip]="info() ?? ''"
        position="right"
        class="sia-info"
        [innerHTML]="infoIcon()"
      >
      </span>
    }
  </mat-label>
  <mat-chip-grid
    #chipGrid
    [style.max-height]="height()"
    class="overflow-y-auto"
  >
    @for (item of listValue(); track item) {
      <mat-chip-row
        (removed)="remove(item)"
        [editable]="true"
        (edited)="edit(item, $event)"
        [aria-description]="'press enter to edit ' + item"
      >
        <span
          [class]="
            !regExp()?.test(item)
              ? 'underline decoration-[--mat-sys-error] decoration-wavy'
              : ''
          "
          class="text-sm"
        >
          {{ item }}
        </span>
        <button matChipRemove [attr.aria-label]="'remove ' + item">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input
      [placeholder]="placeholder()"
      matChipInput
      #chipInput
      [matChipInputFor]="chipGrid"
      [(ngModel)]="currentValue"
      [matAutocomplete]="auto"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add($event)"
      (keydown.tab)="onTabKey($event)"
    />
    <mat-autocomplete
      #chipInputAutocomplete
      #auto="matAutocomplete"
      (optionSelected)="selected($event); chipInput.value = ''"
    >
      @for (value of filteredValue(); track value) {
        <mat-option [value]="value">{{ value }}</mat-option>
      }
    </mat-autocomplete>
  </mat-chip-grid>
</mat-form-field>
